module.exports = __webpack_public_path__ + "img/illustrations-co2-process2@2x 1.0a06d604.png";